import { render } from "./PrivateAdd.vue?vue&type=template&id=1cb88622&scoped=true"
import script from "./PrivateAdd.vue?vue&type=script&lang=js"
export * from "./PrivateAdd.vue?vue&type=script&lang=js"

import "./PrivateAdd.vue?vue&type=style&index=0&id=1cb88622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb88622"]])

export default __exports__